const ServiceFilterTypes = {
  HEALTH: "filterHealth",
  OTHER: "filterOther",
  STATUS: "filterStatus",
  LABELS: "filterLabels",
  TEXT: "searchString"
};

module.exports = ServiceFilterTypes;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceFilterTypes.js